import server from "@/api/server";

/**
 * Вывод списка всех заявок на вывод.
 *
 * @param {Object} data
 * @param {string} data.page
 * @param {string} data.pageSize
 * @param {string} data.filter фильтрация возможна по полям: dadd
 * @param {string} data.search_query поисковая строка для поиска в полях: inn, client_name, profile_id, requisistes
 */

async function getPayoutList(data) {
  let res = await server.post("agent/billing/demand_payouts/list", data);
  return res;
}

/**
 * @param {Object} data 
 * @param {string} [data.id]
 * @param {boolean} [data.result]
 */
async function conslusionPayout(data) {
  let res = await server.post("agent/billing/demand_payouts/conclusion", data);
  return res;
}

export {
  getPayoutList,
  conslusionPayout
};

